import { render, staticRenderFns } from "./AudioSetting.vue?vue&type=template&id=187c09c3&"
import script from "./AudioSetting.vue?vue&type=script&lang=js&"
export * from "./AudioSetting.vue?vue&type=script&lang=js&"
import style0 from "./AudioSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports